import { jsx as _jsx } from "react/jsx-runtime";
import { Form } from 'semantic-ui-react';
import DropdownField from '../../../formFields/dropdownField';
import RadioGroupField from '../../../formFields/radioGroupField';
const SingleSelect = ({ definition, value, elmId, onChange, }) => {
    const options = definition.options.map(option => ({
        key: option.value,
        text: option.label,
        value: option.value,
    }));
    return (_jsx(Form, { children: definition.styleIntent?.controlVariant === 'inline-radio' ? (_jsx(RadioGroupField, { name: definition.name, label: '', elmId: `${elmId}_${definition.name}`, options: definition.options, value: value || '', onChange: (_e, input) => {
                onChange(definition.name, input.value || null);
            }, hideWrapper: true })) : (_jsx(DropdownField, { name: definition.name, placeholder: definition.placeholder || 'Select', label: '', elmId: `${elmId}_${definition.name}`, options: options, value: value, onChange: (newValue) => {
                onChange(definition.name, newValue);
            }, search: false, wrapSelection: false, fluid: true, hideWrapper: true })) }));
};
export default SingleSelect;
//# sourceMappingURL=singleSelect.js.map